export const thirdStepFormValues = {
  firstname: "",
  lastname: "",
  secondlastname: "",
  email: "",
};
